import { apiSlice } from '@greenkub-fronts/data-access';

export class Injector {
  public static getDependencies(): { apiSlice: any } {
    // get other dependencies like s3Client and other in the return list to use it in use case with extra argument of createAsyncThunk
    return { apiSlice /**, s3Client */ };
  }
}
